// Set up priority modal listener before DOM ready to catch early events
(function() {
  const priorityModal = document.querySelector('[data-priority-modal]');

  if (priorityModal) {
    // Mark that we're waiting for priority modal
    document.documentElement.dataset.waitingForPriorityModal = 'true';

    // Listen for priority modal resolution
    document.addEventListener('priority-modal-resolved', function() {
      document.documentElement.dataset.priorityModalResolved = 'true';
      delete document.documentElement.dataset.waitingForPriorityModal;

      // Trigger the Revaree popup show function if DOM is already ready
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        showRevareePopup();
      }
    }, { once: true });
  }

  function showRevareePopup() {
    if (!localStorage.getItem("revareePopupDismissed")) {
      const popup = document.querySelector('.revaree-popup-popup');
      if (popup) {
        popup.classList.remove('disable-popup');
        document.body.classList.add('overflow-hidden');
      }
    }
  }

  // Initialize when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRevareePopup);
  } else {
    initRevareePopup();
  }

  function initRevareePopup() {
    if (!localStorage.getItem("revareePopupDismissed")) {
      const popup = document.querySelector('.revaree-popup-popup');
      if (popup) {
        // Check if priority modal already resolved or doesn't exist
        const alreadyResolved = document.documentElement.dataset.priorityModalResolved === 'true';

        if (!priorityModal || alreadyResolved) {
          // No priority modal or already resolved, show immediately
          showRevareePopup();
        }
        // Otherwise, the event listener above will handle showing it
      }
    }
  }
})();

$(document).ready(function(){
  $(document).on('click', '.revaree-popup-popup-close, .revaree-popup-no-thanks-text, .revaree-popup-popup', function(e){
    if ($(e.target).hasClass('revaree-popup-popup') || $(e.target).hasClass('revaree-popup-popup-close') || $(e.target).hasClass('revaree-popup-no-thanks-text')) {
      $('.revaree-popup-popup').addClass('disable-popup');
      $('body').removeClass('overflow-hidden');
      localStorage.setItem('revareePopupDismissed', 'true');
    }
  });

  $(document).on('click', '.revaree-popup-popup-copy-code-cta', function() {
    let textToCopy = $('.revaree-popup-popup-offer-text span').text();
    navigator.clipboard.writeText(textToCopy).then(function() {
      $('.revaree-popup-copied-text').css('display', 'block');
      $('.revaree-popup-text').css('display', 'none');
    }).catch(function(error) {
      console.error('Error copying text: ', error);
    });
  });
});

